import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';

export function getIntegrationStrings(): object {
  return {
    integrationDescription: translateFn(
      'Follow the steps below to connect the Bitdefender Container Image Scanner to GravityZone, making scan results available in the Risk management section.'
    ),

    configurationTitle: translateFn('Configuration'),
    companyFormFieldLabel: translateFn('Company'),
    companyFormFieldPlaceholder: translateFn('Choose company'),
    companyFormFieldSearchPlaceholder: translateFn('Search'),
    companyFormFieldNoSearchResults: translateFn('No options found'),
    integrationNameFormFieldLabel: translateFn('Integration name'),

    checkRequirementsHeader: translateFn('Check requirements'),
    checkRequirementsDescription: translateFn(
      'Install <b>docker</b> and <b>wget</b> directly on your host system or in the CI/CD execution environment.'
    ),

    connectScannerHeader: translateFn('Connect scanner to GravityZone'),
    connectScannerStep1: translateFn('Run the following command to download the Bitdefender scanner tarball:'),
    connectScannerStep2: translateFn('Extract the downloaded archive:'),
    connectScannerStep3: translateFn('Verify that the extracted executable runs without issues:'),
    connectScannerStep4: translateFn('Copy the following URL:'),
    connectScannerStep5: translateFn('Configure the Bitdefender scanner with the previously copied URL:'),
    connectScannerStep6: translateFn('Copy the following access token:'),
    connectScannerStep7: translateFn('Authenticate the Bitdefender scanner with the previously copied token:'),
    connectScannerFooter: translateFn('For a complete Bitdefender Container Image Scanner guide, refer to'),
    connectScannerKBLink: translateFn('this KB article.'),

    connectScannerStep1Text: translateFn('Alternatively, use this link to download the archive:'),
    connectScannerBinaryLink: translateFn('Download binary.'),

    downloadScannerTitle: translateFn('Download Bitdefender scanner'),
    authScannerTitle: translateFn('Authenticate Bitdefender scanner'),
  };
}
